import { render } from "./DialogPurchaseVersionWarning.vue?vue&type=template&id=f70a5fa4&scoped=true"
import script from "./DialogPurchaseVersionWarning.vue?vue&type=script&lang=js"
export * from "./DialogPurchaseVersionWarning.vue?vue&type=script&lang=js"

import "./DialogPurchaseVersionWarning.vue?vue&type=style&index=0&id=f70a5fa4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f70a5fa4"

export default script